module.exports = __webpack_public_path__ + "img/avatar.f1ca2b1e.png";